import { primaryColorLight } from './colors';
import ValidationInput from "../components/ProjectIdCardEdit";
import {CharacteristicWrapper} from "../components/ProjectIdCardEdit/styles";

export const user_roles = {
  admin: 'ROLE_ADMIN',
  castAdmin: 'ROLE_CAST_ADMIN',
  viewer: 'ROLE_VIEWER',
  catalogViewer: 'ROLE_CATALOG_VIEWER',
  catalogAdmin: 'ROLE_CATALOG_ADMIN',
  catalogProjectAdmin: 'ROLE_CATALOG_PROJECT_ADMIN',
  catalogProjectEditor: 'ROLE_CATALOG_PROJECT_EDITOR',
  stViewer: 'ROLE_ST_VIEWER',
  stAdmin: 'ROLE_ST_ADMIN',
  stFraming: 'ROLE_ST_FRAMING',
  stProject: 'ROLE_ST_PROJECT',
  projectAdmin: 'ROLE_PROJECT_ADMIN',
};

export const MODAL_ACTION = {
  IS_OPEN: 'modalIsOpen',
  TITLE: 'modalTitle',
  DESCRIPTION: 'modalDescription',
  ON_CLOSE: 'onCloseModal',
  ON_LEFT_BTN: 'onBtnLeftClick',
  ON_RIGHT_BTN: 'onBtnRightClick',
};

export const DESIGN_MATURITY_OPTIONS = [
  {
    value: 'Concept Design',
    label: '(15%) Concept Design',
  },
  {
    value: 'Basic Design',
    label: '(30%) Basic Design',
  },
  {
    value: 'Detail Design - Phase 1',
    label: '(60%) Detail Design - Phase 1',
  },
  {
    value: 'Detail Design - Phase 2',
    label: '(80%) Detail Design - Phase 2',
  },
  {
    value: 'As-Built',
    label: '(90%) As-Built',
  },
  {
    value: 'In Operation',
    label: '(100%) In Operation',
  },
];

export const STANDARDIZATION_INTENT_SCORE_OPTIONS = [
  {
    value: 30,
    label: '30% Low',
  },
  {
    value: 60,
    label: '60% Medium',
  },
  {
    value: 90,
    label: '90% High',
  },
  {
    value: 100,
    label: '100% Replication',
  },
];

export const POSITION_OPTIONS = [
  {
    value: 'Portside',
    label: 'Portside',
  },
  {
    value: 'Starboard',
    label: 'Starboard',
  },
];

export const VENDOR_OR_EPC_OPTIONS = [
  {
    value: 'Vendor',
    label: 'Vendor',
  },
  {
    value: 'EPC',
    label: 'EPC',
  },
];

export const CONTRACT_TYPE_OPTIONS = [
  {
    value: 'LEASE',
    label: 'Lease and operate',
  },
  {
    value: 'SALE',
    label: 'Sale',
  },
  {
    value: 'BOT',
    label: 'BOT',
  },
  {
    value: 'OTHER',
    label: 'Other',
  },
];

export const MOORING_SYSTEM_OPTIONS = [
  {
    value: 'SPREAD_MOORED',
    label: 'Spread moored',
  },
  {
    value: 'TURRET_MOORED',
    label: 'Turret moored',
  },
];
